import Vue from 'vue';
import {WinForm} from '@/libs';

Vue.directive('resizeWidth', {

  inserted: function (el: any) {
    if(el.id) {
      let width = WinForm.storge.get(`resize_width_${el.id}`);
      if (width) {
        el.style.width = width
      } else {
        el.style.width = '230px'
      };
    }
    let document = (window as any).document;
    el.onmousedown = function (event: any) {
      if (!event.path[0].classList.contains("md-el-aside") && !event.path[0].classList.contains("md-el-aside-left") && !event.path[0].classList.contains("md-el-aside-right")) {
        return;
      }
      let originWidth = el.clientWidth/* event.target.offsetWidth*/, originX = event.clientX;
      let width: string;
      document.onmousemove = function (e: any) {
        e.preventDefault();
        e.stopPropagation();
        if (event.path[0].classList.contains("md-el-aside-right")) {
          if (parseInt(event.target.style.width) >= 520 && (parseInt(e.clientX) - parseInt(originX)) < 0) {
            event.target.style.width = '520px';
            document.onmousemove = null;
          } else if (parseInt(event.target.style.width) <= 190 && (parseInt(e.clientX) - parseInt(originX)) > 0) {
            event.target.style.width = '190px';
            document.onmousemove = null;
          } else {
            width = originWidth + (e.clientX + 5 - originX) + 'px';
            event.target.style.width = width ;
          }
        } else if(event.path[0].classList.contains("md-el-aside-left")) {
          width = originWidth + (originX - 5 - e.clientX ) + 'px';
          event.target.style.width = width;
        } else {
          width = originWidth + (e.clientX + 5 - originX) + 'px';
          event.target.style.width = width;
        }

      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
        if (el.id) {
          WinForm.storge.set(`resize_width_${el.id}`, width);
        }
      };
    }
  }
});